export default __webpack_public_path__ + "static/media/section2-bg4.4d8d33a3.png";